import { Type, type Static } from "typebox";

export const SuiteErrorV1Schema = Type.Object({
  code: Type.String({ pattern: "^[a-z][a-z0-9_]{1,63}$" }),
  message: Type.String({ minLength: 1, maxLength: 240 }),
  requestId: Type.String({ minLength: 1, maxLength: 128 }),
  retryable: Type.Boolean(),
  fieldErrors: Type.Optional(Type.Record(Type.String({ maxLength: 64 }), Type.String({ maxLength: 160 }))),
}, { additionalProperties: false });
export type SuiteErrorV1 = Static<typeof SuiteErrorV1Schema>;
